<ng-container *transloco="let t">
  <div
    class="z-popup-lov"
    [class.is-readonly]="readonly"
    [class.is-disabled]="readonly"
    [class.with-dropdown-list]="enableDropdown"
    [class.with-label]="!!label"
    [class.with-hint]="!!hint"
    [class.has-value]="hasValue$ | async"
    [class.is-invalid]="isInvalid$ | async"
    [ngClass]="styleClass"
    [class.with-multi-select]="allowMultipleValues"
  >
    <label [for]="id" *ngIf="!!label && !hideLabel">
      {{ label }}
    </label>

    <z-match-type
      *ngIf="matchTypes"
      type="string"
      [enableBetweenMatchType]="false"
      [controlWithoutLabel]="!label || hideLabel"
      [defaultMatchType]="defaultMatchType"
      [inputGroup]="true"
      (change)="onMatchTypeChange($event)"
    ></z-match-type>

    <div class="p-inputgroup" [formGroup]="formGroup.form">
      <input
        #input
        *ngIf="!enableDropdown"
        zTextInput
        [id]="id"
        [formControlName]="fieldName"
        [placeholder]="placeholder"
        [readonly]="!manualInput"
        [clearButton]="clearButton"
        [uppercase]="uppercase"
        [numeric]="numeric"
        [currency]="currency"
        [decimal]="decimal"
        [allowedCharacters]="allowedCharacters"
        [class.popup-lov-input-text]="true"
        (clear)="onClear($event)"
        (onChange)="onChangeHandler($event)"
        [displayValidationErrors]="false"
      />

      <p-multiSelect
        #multiSelect
        *ngIf="enableDropdown && allowMultipleValues"
        appendTo="body"
        [filter]="showDropdownFilter"
        [filterBy]="dropdownFilterBy"
        [formControlName]="fieldName"
        [inputId]="id"
        [optionLabel]="dropdownOptionLabelColumn"
        [options]="list"
        [optionValue]="dropdownOptionValueColumn"
        [panelStyle]="dropdownPanelMinWidthStyle"
        panelStyleClass="z-combo-box z-combo-box-multi virtualDropdownFixedWidth"
        [placeholder]="placeholder"
        [readonly]="readonly || disabled"
        [scrollHeight]="dropdownPanelHeight$ | async"
        [selectionLimit]="selectionLimit"
        [showHeader]="showDropdownFilter"
        [showToggleAll]="showToggleAll"
        [styleClass]="blockId + '-multi-select'"
        [virtualScroll]="virtualScroll"
        [virtualScrollItemSize]="dropdownItemSize"
        [class.p-disabled]="readonly || disabled"
        (onClick)="onClick($event)"
        (onFocus)="onFocus($event)"
        (onBlur)="onBlur($event)"
        (onPanelShow)="onMultiSelectPanelShow($event)"
        (onPanelHide)="onMultiSelectPanelHide($event)"
        (onFilter)="onFilterMultiSelect($event)"
        (onChange)="onChange($event)"
      >
        <ng-template let-value pTemplate="selectedItems">
          <span class="selected-items" [pTooltip]="tooltipValue$ | async" tooltipPosition="bottom" [showDelay]="500">
            <!-- value can be an array or a string -->
            <ng-container *ngIf="(value | typeof) === 'object'">
              <ng-container *ngFor="let item of value; let i = index">
                <span class="multi-select-label">{{ item }}<ng-container *ngIf="i < value.length - 1">, </ng-container></span>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="(value | typeof) === 'string'">
              <ng-container *ngFor="let item of value.split(','); let i = index">
                <span class="multi-select-label">{{ item }}<ng-container *ngIf="i < value.split(',').length - 1">, </ng-container></span>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="!value || value.length === 0">
              {{ placeholder }}
            </ng-container>
          </span>
        </ng-template>

        <ng-template let-data pTemplate="item">
          <span class="dropdown-item">
            <span [class]="columnsConfig.column1.class" *ngIf="columnsConfig.column1.display">
              {{ data[columnsConfig.column1.key] }}
            </span>

            <span [class]="columnsConfig.column2.class" *ngIf="columnsConfig.column2.display">
              {{ data[columnsConfig.column2.key] }}
            </span>

            <span [class]="columnsConfig.column3.class" *ngIf="columnsConfig.column3.display">
              {{ data[columnsConfig.column3.key] }}
            </span>

            <span [class]="columnsConfig.column4.class" *ngIf="columnsConfig.column4.display">
              {{ data[columnsConfig.column4.key] }}
            </span>

            <span [class]="columnsConfig.column5.class" *ngIf="columnsConfig.column5.display">
              {{ data[columnsConfig.column5.key] }}
            </span>
          </span>
        </ng-template>
      </p-multiSelect>

      <z-clear-button
        *ngIf="!enableDropdown && allowMultipleValues && clearButton && !readonly"
        (click)="onMultiSelectClear($event)"
      ></z-clear-button>

      <p-dropdown
        #dropdown
        *ngIf="enableDropdown && !allowMultipleValues"
        appendTo="body"
        [autoDisplayFirst]="false"
        [filter]="showDropdownFilter"
        [filterBy]="dropdownFilterBy"
        [formControlName]="fieldName"
        [inputId]="id"
        [optionLabel]="dropdownOptionLabelColumn"
        [options]="list"
        [optionValue]="dropdownOptionValueColumn"
        [panelStyle]="dropdownPanelMinWidthStyle"
        panelStyleClass="z-popup-lov"
        [placeholder]="placeholder"
        [readonly]="readonly || disabled"
        [scrollHeight]="dropdownPanelHeight$ | async"
        [showClear]="clearButton && !readonly"
        [styleClass]="blockId + '-dropdown'"
        [virtualScroll]="virtualScroll"
        [virtualScrollItemSize]="dropdownItemSize"
        [class.p-disabled]="readonly || disabled"
        (onClick)="onClick($event)"
        (onFocus)="onFocus($event)"
        (onBlur)="onBlur($event)"
        (onShow)="onDropDownPanelShow($event)"
        (onHide)="onDropDownPanelHide($event)"
        (onClear)="onClear($event)"
        (onFilter)="onFilterDropdown($event)"
        (onChange)="onChangeHandler($event)"
      >
        <ng-template let-data pTemplate="selectedItem">
          <span class="selected-item" [pTooltip]="data[selectedItemDescriptionColumn]" tooltipPosition="bottom" [showDelay]="500">
            <span class="label">{{ data[selectedItemLabelColumn] }}</span>
            <span class="description" *ngIf="selectedItemShowDescription"> ({{ data[selectedItemDescriptionColumn] }})</span>
          </span>
        </ng-template>

        <ng-template let-data pTemplate="item">
          <span class="dropdown-item">
            <span [class]="columnsConfig.column1.class" *ngIf="columnsConfig.column1.display">
              {{ data[columnsConfig.column1.key] }}
            </span>

            <span [class]="columnsConfig.column2.class" *ngIf="columnsConfig.column2.display">
              {{ data[columnsConfig.column2.key] }}
            </span>

            <span [class]="columnsConfig.column3.class" *ngIf="columnsConfig.column3.display">
              {{ data[columnsConfig.column3.key] }}
            </span>

            <span [class]="columnsConfig.column4.class" *ngIf="columnsConfig.column4.display">
              {{ data[columnsConfig.column4.key] }}
            </span>

            <span [class]="columnsConfig.column5.class" *ngIf="columnsConfig.column5.display">
              {{ data[columnsConfig.column5.key] }}
            </span>
          </span>
        </ng-template>
      </p-dropdown>

      <button
        pButton
        type="button"
        icon="fa fa-arrow-up-right-from-square"
        class="p-button-outlined p-button-secondary"
        [disabled]="readonly"
        (click)="actionButtonHandler()"
        pTooltip="{{ t('core.components.popup_lov.open_popup_tooltip') }}"
        tooltipPosition="bottom"
        [showDelay]="500"
      ></button>
    </div>

    <z-hint *ngIf="!!hint" [text]="hint"></z-hint>

    <z-validation *ngIf="displayValidationErrors" [control]="this.formGroup.form.controls[this.fieldName]"></z-validation>
  </div>
</ng-container>
